import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import Show from 'Components/Show/Show';
import RecurringPaymentReceiptPopup from 'Popups/RecurringPaymentReceiptPopup/RecurringPaymentReceiptPopup';
import React, { useState } from 'react'
import { LuReceipt, LuCircleCheck, LuCircleX, LuCalendar, LuChevronDown, LuClock, LuCopy, LuPen } from "react-icons/lu";
import { FiAlertCircle } from "react-icons/fi";
import NumberConversion from 'Utils/NumberConversion';
import { PAYMENT_FREQUENCIES } from 'Common/Constants';
import api from 'http';
import isNull from 'Utils/isNull';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import Dropdown from 'Common/DropDown/Dropdown';
const PaymentPlanCard = ({ plan, onMakePayment, onEditPlan, handleChangePayment }) => {
  const [showSchedule, setShowSchedule] = useState(false);
  const [showReceiptPopup, setShowReceiptPopup] = useState({
    status: false,
    selectedPayment: null
  });
  const [copiedText, setCopiedText] = useState(null);

  const formatCurrency = (value) => {
    return NumberConversion(value, false);
  };

  const copyToClipboard = async (text) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setTimeout(() => setCopiedText(null), 2000);
    } catch (error) {
      ErrorHandlingMessage(error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'text-green-700';
      case 'Paused':
        return 'text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded';
      case 'Completed':
        return 'text-blue-700';
      case 'Cancelled':
        return 'text-red-700';
      default:
        return 'text-slate-700';
    }
  };
  const calculateRemaining = () => {
    if (plan.planType === 'subscription') return null;

    const totalPaid = plan.installments?.filter(item => item.status === 'Paid')
      .reduce((sum, item) => sum + item.amount, 0) || 0;

    return (plan.totalBalance || 0) - totalPaid;
  };

  const calculateProgress = () => {
    if (plan.planType === 'SUB') {
      if (!plan.finalPaymentDate) return 0;
      const totalAmount = plan.installments?.reduce((sum, item) => sum + item.amount, 0) || 0;
      const totalPaid = plan.installments?.filter(item => item.status === 'Paid')
        .reduce((sum, item) => sum + item.amount, 0) || 0;

      return Math.min(((totalPaid / (totalAmount || 1)) * 100), 100);
    } else {
      const totalPaid = plan.installments?.filter(item => item.status === 'Paid')
        .reduce((sum, item) => sum + item.amount, 0) || 0;

      return Math.min(((totalPaid / (plan.totalBalance || 1)) * 100), 100);
    }
  };

  const getNextPayment = () => {
    if (!plan.installments) return null;
    return plan.installments.find(item => item.status === 'Next' || item.status === 'overdue') || null;
  }

  const handleCloseViewReceipt = () => {
    setShowReceiptPopup({
      status: false,
      selectedPayment: null
    })
  }
  const openPaymentReceipt = async (payment) => {
    if (isNull(payment.paymentMainId)) return
    try {
      const resp = await api.get(process.env.REACT_APP_TC_PMS + `/api/PatientPayment/FindPaymentReceipt/${payment.paymentMainId}`)
      window.open(resp.data.dataModel.receiptPresignedUrl, "_blank");
    } catch (error) {
      ErrorHandlingMessage(error);
    }

  };



  const remaining = calculateRemaining();
  const progress = calculateProgress();

  const nextPayment = getNextPayment();

  const showfinalPaymentDate = plan.planType === 'SUB' ? plan.finalPaymentDate : true

  const getPlanTitle = () => {
    if (plan.planType === 'BAL') {
      return `${formatCurrency(plan.totalBalance)} ${plan.planDescription}`;
    }
    return plan.planDescription;
  };

  const getDateRange = () => {
    const startDate = new Date(plan.firstPaymentDate).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    if (showfinalPaymentDate && plan.finalPaymentDate) {
      const endDate = new Date(plan.finalPaymentDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
      return `${startDate} - ${endDate}`;
    }
    return startDate;
  };

  const getNextPaymentDate = () => {
    if (nextPayment) {
      return new Date(nextPayment.scheduledDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
    return null;
  };

  return (
    <>
      <Show when={showReceiptPopup.status}>
        <RecurringPaymentReceiptPopup onClose={handleCloseViewReceipt} payment={showReceiptPopup.selectedPayment} planDescription={plan.planDescription} />
      </Show>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-blue-50 rounded flex items-center justify-center flex-shrink-0">
                <LuReceipt className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-900">{getPlanTitle()}</h3>
                <Show when={plan.patientName || plan.accountNumber}>
                  <div className="flex items-center gap-3 mt-2">
                    <Show when={plan.patientName}>
                      <button
                        onClick={() => copyToClipboard(plan.patientName)}
                        className="flex items-center gap-1.5 text-sm text-slate-700 hover:text-blue-600 transition-colors group"
                      >
                        <span className="font-medium">{plan.patientName}</span>
                        {copiedText === plan.patientName ? (
                          <LuCircleCheck className="w-3.5 h-3.5 text-green-600" />
                        ) : (
                          <LuCopy className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                        )}
                      </button>
                      {plan.accountNumber && <span className="text-slate-400">•</span>}
                    </Show>
                    <Show when={plan.accountNumber}>
                      <button
                        onClick={() => copyToClipboard(plan.accountNumber)}
                        className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-blue-600 transition-colors group"
                      >
                        <span>{plan.accountNumber}</span>
                        {copiedText === plan.accountNumber ? (
                          <LuCircleCheck className="w-3.5 h-3.5 text-green-600" />
                        ) : (
                          <LuCopy className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                        )}
                      </button>
                    </Show>
                  </div>
                </Show>
                <div className="flex items-center gap-2 mt-2">
                  {(plan.status === 'Active' || plan.status === 'active') && (
                    <span className={`inline-flex items-center gap-1 text-xs font-medium ${getStatusColor(plan.status)}`}>
                      <LuCircleCheck className="w-3 h-3" />
                      Active
                    </span>
                  )}
                  {(plan.status === 'Paused' || plan.status === 'paused') && (
                    <span className={`inline-flex items-center gap-1 text-xs font-medium ${getStatusColor(plan.status)}`}>
                      <FiAlertCircle className="w-3 h-3" />
                      Paused
                    </span>
                  )}
                  {(plan.status === 'Completed' || plan.status === 'completed') && (
                    <span className={`inline-flex items-center gap-1 text-xs font-medium ${getStatusColor(plan.status)}`}>
                      <LuCircleCheck className="w-3 h-3" />
                      Completed
                    </span>
                  )}
                  {(plan.status === 'Cancelled' || plan.status === 'cancelled') && (
                    <span className={`inline-flex items-center gap-1 text-xs font-medium ${getStatusColor(plan.status)}`}>
                      <LuCircleX className="w-3 h-3" />
                      Cancelled
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="text-right">
              {plan.planType === 'BAL' ? (
                <>
                  <div className="text-lg font-semibold text-slate-900">
                    {formatCurrency(Math.abs(remaining || 0))} remaining
                  </div>
                  <div className="text-sm text-slate-600">
                    {PAYMENT_FREQUENCIES.find((freq) => freq.value === plan.frequency)?.label || plan.frequency} payments of {formatCurrency(plan.recurringAmount)}
                  </div>
                </>
              ) : (
                <>
                  <div className="text-lg font-semibold text-slate-900">
                    {formatCurrency(plan.recurringAmount)}/{plan.frequency}
                  </div>
                  <div className="text-sm text-slate-600">Subscription plan</div>
                </>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 text-sm text-slate-600 mb-3">
            <LuCalendar className="w-4 h-4" />
            <span>{getDateRange()}</span>
          </div>

          {(plan.planType === 'BAL' || (plan.planType === 'SUB' && plan.finalPaymentDate)) && (
            <div className="mb-3">
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="text-slate-600">Progress</span>
                <span className="font-medium text-slate-900">{Math.round(progress)}%</span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2">
                <div
                  className="bg-green-500 h-2 rounded-full transition-all"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          )}

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {nextPayment ? (
                <div className={`flex items-center gap-2 text-sm ${nextPayment.status === 'overdue' || nextPayment.status === 'Overdue' ? 'text-red-600' : 'text-red-600'}`}>
                  <FiAlertCircle className="w-4 h-4" />
                  <span>Next payment due {getNextPaymentDate()}</span>
                </div>
              ) : (
                <div className="flex items-center gap-2 text-sm text-green-600">
                  <LuCircleCheck className="w-4 h-4" />
                  <span>{plan.status === 'completed' || plan.status === 'Completed' ? 'Plan completed' : 'No upcoming payments'}</span>
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowSchedule(!showSchedule)}
                className="px-3 py-1.5 text-sm text-primary hover:bg-[#e8ebfe] border border-primary rounded-lg transition-colors flex items-center gap-1"
              >
                Schedule
                <LuChevronDown className={`w-4 h-4 transition-transform ${showSchedule ? 'rotate-180' : ''}`} />
              </button>
              <Show when={plan.status !== 'Cancelled' && plan.status !== 'cancelled' && plan.status !== 'Ended' && plan.status !== 'ended'}>
              <Dropdown>
  <Dropdown.Button>
    <button className="px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 border border-slate-300 rounded-lg transition-colors flex items-center gap-1">
      <LuPen className="w-4 h-4" />
      Edit
    </button>
  </Dropdown.Button>

  <Dropdown.Menu className="absolute drop-shadow-sm z-[10] w-40 min-w-max rounded-lg bg-white text-left text-base shadow-lg">
    <Dropdown.MenuItem onClick={() => handleChangePayment("CANCEL", plan.id)}>
      <button className="w-full border-b dropdownItemMain">
        Cancel
      </button>
    </Dropdown.MenuItem>

    <Dropdown.MenuItem
      onClick={() => handleChangePayment("PAUSE", plan.id)}
      disabled={plan.status === 'Paused' || plan.status === 'paused'}
      className="border-b dropdownItemMain"
    >
      Pause
    </Dropdown.MenuItem>

    <Show when={plan.status !== 'Active' && plan.status !== 'active'}>
      <Dropdown.MenuItem onClick={() => handleChangePayment("RESUME", plan.id)}>
        <button className="w-full border-b dropdownItemMain">
          Resume
        </button>
      </Dropdown.MenuItem>
    </Show>
  </Dropdown.Menu>
</Dropdown>
              </Show>
              <Show when={plan.showMakePaymentButton}>
                <CustomButtonNew onClick={() => onMakePayment(plan.id)} label="Make a Payment" />
              </Show>
            </div>
          </div>

          {showSchedule && plan.installments && plan.installments.length > 0 && (
            <div className="mt-4 pt-4 border-t border-slate-200">
              <h4 className="text-sm font-semibold text-slate-700 mb-3">Payment Schedule</h4>
              <div className="space-y-2">
                <div className="grid grid-cols-4 gap-4 px-4 py-2 bg-slate-50 rounded text-xs font-semibold text-slate-600 uppercase">
                  <div>#</div>
                  <div>Date</div>
                  <div>Amount</div>
                  <div>Status</div>
                </div>
                {plan.installments.map((payment, index) => (
                  <div key={payment.id} className="grid grid-cols-4 gap-4 px-4 py-2 text-sm">
                    <div className="text-slate-900">{index + 1}</div>
                    <div className="text-slate-700">
                      {new Date(payment.scheduledDate).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </div>
                    <div className="font-medium text-slate-900">{formatCurrency(payment.amount)}</div>
                    <div>
                      {payment.status === 'Paid' || payment.status === 'paid' ? (
                        <div className="flex items-center gap-1">
                          <LuCircleCheck className="w-4 h-4 text-green-600" />
                          <span className="text-green-700 font-medium">Paid</span>
                          <button
                            onClick={() => openPaymentReceipt(payment)}
                            className="ml-2 text-blue-600 hover:underline text-xs"
                          >
                            Receipt
                          </button>
                        </div>
                      ) : payment.status === 'Next' || payment.status === 'next' ? (
                        <div className="flex items-center gap-1">
                          <LuClock className="w-4 h-4 text-blue-600" />
                          <span className="text-blue-700 font-medium capitalize">{payment.status}</span>
                        </div>
                      ) : payment.status === 'Overdue' || payment.status === 'overdue' ? (
                        <div className="flex items-center gap-1">
                          <LuCircleX className="w-4 h-4 text-red-600" />
                          <span className="text-red-700 font-medium capitalize">{payment.status}</span>
                        </div>
                      ) : (
                        <span className="text-slate-700 capitalize">{payment.status}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default PaymentPlanCard

